import { render, staticRenderFns } from "./SetupCenter.vue?vue&type=template&id=46f7a3b2&scoped=true"
import script from "./SetupCenter.vue?vue&type=script&lang=js"
export * from "./SetupCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7a3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f7a3b2')) {
      api.createRecord('46f7a3b2', component.options)
    } else {
      api.reload('46f7a3b2', component.options)
    }
    module.hot.accept("./SetupCenter.vue?vue&type=template&id=46f7a3b2&scoped=true", function () {
      api.rerender('46f7a3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/SetupCenter.vue"
export default component.exports